import { makeAutoObservable } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { ActiveClientsTabStore } from 'pages/clients/store/activeClientsTabStore'
import { PendingClientsTabStore } from 'pages/clients/store/pendingClientsTabStore'

export class ClientsPageStore {
  readonly activeClientsTabStore: ActiveClientsTabStore
  readonly pendingClientsTabStore: PendingClientsTabStore

  constructor(readonly entities: IEntitiesStore) {
    this.activeClientsTabStore = new ActiveClientsTabStore(this.entities)
    this.pendingClientsTabStore = new PendingClientsTabStore()
    makeAutoObservable(this)
  }

  dispose = () => {
    this.activeClientsTabStore.dispose()
    this.pendingClientsTabStore.dispose()
  }
}
